import React, { useState } from 'react';
import { cn } from "@/lib/utils";

interface TooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
}

export function Tooltip({ 
  children, 
  content, 
  side = 'top', 
  className 
}: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);

  const positions = {
    top: '-top-2 left-1/2 -translate-x-1/2 -translate-y-full',
    right: 'top-1/2 -right-2 translate-x-full -translate-y-1/2',
    bottom: '-bottom-2 left-1/2 -translate-x-1/2 translate-y-full',
    left: 'top-1/2 -left-2 -translate-x-full -translate-y-1/2'
  };

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onFocus={() => setIsVisible(true)}
        onBlur={() => setIsVisible(false)}
      >
        {children}
      </div>
      {isVisible && (
        <div
          className={cn(
            "absolute z-50 px-2 py-1 text-xs text-white bg-gray-900 rounded pointer-events-none",
            "animate-in fade-in-0 zoom-in-95",
            positions[side],
            className
          )}
          role="tooltip"
        >
          {content}
          <div
            className={cn(
              "absolute w-2 h-2 bg-gray-900 rotate-45",
              {
                'top-full left-1/2 -translate-x-1/2 -translate-y-1/2': side === 'bottom',
                'bottom-full left-1/2 -translate-x-1/2 translate-y-1/2': side === 'top',
                'left-full top-1/2 -translate-x-1/2 -translate-y-1/2': side === 'right',
                'right-full top-1/2 translate-x-1/2 -translate-y-1/2': side === 'left',
              }
            )}
          />
        </div>
      )}
    </div>
  );
} 